import { FDInvestmentJourneyResponseType, FundTypeEnum } from '../../../types/fd-type'
import { formatTimePeriod } from '../../../utils/FD/fd'
import RenderHTML from '../../ui-components/RenderHTML'
import { InvestmentSummary } from './InvestmentSummary'
import * as d3 from 'd3'

export const InvestmentSummaryStep = ({
  data,
  currentInvestment,
  maturityAmount
}: {
  data: FDInvestmentJourneyResponseType | undefined
  currentInvestment: number
  maturityAmount: number
}) => {
  const formatMaturityDate = (timestamp: number | undefined) => {
    if (!timestamp) return ''
    return d3.timeFormat('%d %b %Y')(new Date(timestamp))
  }

  return (
    <div className='flex flex-col justify-center px-5 w-full h-full'>
      <div className='flex flex-col justify-center'>
        <div className='text-white text-[32px] font-[500] leading-[120%] text-center w-full'>
          Does everything look good?
        </div>
        <div className='pt-8 w-full'>
          <InvestmentSummary
            bankName={data?.institutionName ?? ''}
            logoSrc={data?.logoUrl ?? ''}
            interestRate={`${data?.interestRate}%`}
            tenure={`${formatTimePeriod((data?.tenure ?? 0) / 365)}`}
            investingAmount={currentInvestment}
            maturityAmount={maturityAmount}
            maturityDate={formatMaturityDate(data?.maturityTime)}
          />
        </div>
      </div>
      {data?.fundType === FundTypeEnum.BANK && (
        <div className='pt-10 pb-5 flex justify-center'>
          <div className='flex flex-col items-center'>
            <div className='text-[#A2FFA0] font-[500] text-center flex gap-2 items-center text-nowrap'>
              <div className='scale-125'>
                <RenderHTML innerHTMLText={ShieldIcon} />
              </div>
              <div>Insured by DICGC | Withdraw Anytime</div>
            </div>
            <div className='text-center leading-[150%] text-[#D1ECFF] font-[400] text-[14px] pt-2'>
              Your investments are secure. {data?.planSecuredBy}, and you can withdraw anytime after{' '}
              {data?.lockInPeriodInDays}D.
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export const ShieldIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <g clip-path="url(#clip0_8755_7066)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.427734 1.7154C0.427734 1.00532 1.00337 0.429688 1.71345 0.429688H10.2849C10.9949 0.429688 11.5706 1.00532 11.5706 1.7154V4.00864C11.5706 7.4305 9.38093 10.4685 6.13469 11.5505C6.04672 11.5799 5.95161 11.5799 5.86364 11.5505C2.61737 10.4685 0.427734 7.4305 0.427734 4.00864V1.7154ZM9.05111 3.85678C9.28691 3.59142 9.26308 3.18509 8.99771 2.94922C8.73233 2.71334 8.32599 2.73724 8.09011 3.00261L5.05452 6.41764L3.81345 5.48684C3.52942 5.27381 3.12647 5.33138 2.91345 5.61541C2.70042 5.89944 2.75799 6.30238 3.04202 6.51541L4.75631 7.80112C5.02378 8.00173 5.40037 7.96382 5.6225 7.71393L9.05111 3.85678Z" fill="#A2FFA0"/>
  </g>
  <defs>
    <clipPath id="clip0_8755_7066">
      <rect width="12" height="12" fill="white"/>
    </clipPath>
  </defs>
</svg>`
